import { ChangeDetectorRef, Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { HelpService } from 'mbs-ui-shared@help/help.service';
import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { RestoreDatabaseModelForStepsHelper } from 'wizards/helpers/restore-database-helpers/restore-database-model-for-steps-helper';
import { RestoreDatabasePlanFromStepsHelpers } from 'wizards/helpers/restore-database-helpers/restore-database-plan-from-steps-helpers';
import { RestoreDatabaseFormModel } from 'wizards/models/databaseRestore/restore-database-form-model';
import { RestoreType } from 'wizards/models/restore-point-models';
import { RestoreAsDiskEnum } from 'wizards/models/type-data-models';
import { WizardStepsService } from 'wizards/services/wizard-steps.service';
import { WizardsServicesHubService } from 'wizards/services/wizards-services-hub.service';
import { StepLoadInfo } from 'wizards/steps/StepBase.class';
import { WizardBaseClass } from '../wizard-base.class';

@UntilDestroy()
@Component({
  selector: 'mbs-database-restore-wizard',
  templateUrl: './database-restore-wizard.component.html'
})
export class DatabaseRestoreWizardComponent extends WizardBaseClass {
  public readonly backupToRestoreTitle = this.i18nPipe.transform('wizards:backupToRestoreTitle', { format: 'title' });
  public readonly restorePointTitle = this.i18nPipe.transform('wizards:restore_point_title', { format: 'title' });
  public readonly serverInstanceTitle = this.i18nPipe.transform('wizards:sql:sqlServerInstanceStepMenuTitle', { format: 'title' });
  protected readonly restoreAsDiskEnum = RestoreAsDiskEnum;

  public restoreType = RestoreType;

  get getInstances(): { Name: string }[] {
    return (
      this.loadedPlan?.DatabaseServerInstances || [
        { Name: this.FormModel?.sqlServerInstanceStep?.sqlServerInstanceName || this.mainService?.compName || '' }
      ]
    );
  }

  get isRestoreDatabase(): boolean {
    return this.planType === PlanTypes.RestoreDataBasePlan;
  }

  constructor(
    private cdr: ChangeDetectorRef,
    public services: WizardsServicesHubService,
    public i18nPipe: I18NextPipe,
    stepService: WizardStepsService,
    helpService: HelpService
  ) {
    super(services, i18nPipe, stepService, helpService);

    this.FormModel = new RestoreDatabaseFormModel(this.isNBF, this.isRestoreDatabase);

    this.initSubscribes();
  }

  updateStepData(plan, isDefault = false): void {
    this.loadedPlan = plan;
    if (this.isEdit && !this.isRDMode) this.mainService.GetPlanNotificationOptions();

    if (isDefault) return this.setDefaultValue();

    this.FormModel = RestoreDatabaseModelForStepsHelper.restoreDatabaseModelFromPlan(plan, this.defaultSettings());
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected loadInfoHandlerFinally(event?: StepLoadInfo): void {
    this.cdr.detectChanges();
  }

  handleSave(): void {
    const newPlan = RestoreDatabasePlanFromStepsHelpers.getUpdatedPlan(this.loadedPlan.Plan, this.FormModel, this.defaultSettings());
    this.savePlan(newPlan);
  }
}
